import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { IfHasEntitlementDirective, IfHasAnyEntitlementDirective, IfHasAllEntitlementsDirective } from './directives';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ImpersonationInterceptor } from './interceptors/impersonation.interceptor';

import { UserSessionService } from './services/user-session.service';
import { NHA403Component } from './components/403/403.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		MatButtonModule,
		MatIconModule,
		NHA403Component,
		IfHasEntitlementDirective,
		IfHasAnyEntitlementDirective,
		IfHasAllEntitlementsDirective
	],
	exports: [NHA403Component, IfHasEntitlementDirective, IfHasAnyEntitlementDirective, IfHasAllEntitlementsDirective],
	providers: []
})
export class NHAAuthModule {
	static forRoot(): ModuleWithProviders<NHAAuthModule> {
		return {
			ngModule: NHAAuthModule,
			providers: [
				{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
				{ provide: HTTP_INTERCEPTORS, useClass: ImpersonationInterceptor, multi: true },
				UserSessionService
			]
		};
	}
}
